export const generateKey = pre => `k_${pre}`;

export const applyPageBackground = (color) => {
  const value = color || '';
  document.documentElement.style.backgroundColor = value;
  document.body.style.backgroundColor = value;
  const router = document.querySelector('.router');
  if (router) router.style.backgroundColor = value;
};

export const removeSpacing = pre => {
  pre = pre.replace(/\s+/g, '-').toLowerCase();
  return pre
};

export const fixBackground = () => {
  setTimeout(() => {
    document.querySelector('body').classList.add('fix-background');
  }, 500);
}


export const unFixBackground = () => {
  document.querySelector('body').classList.remove('fix-background');
}



// WEBPACK FOOTER //
// ./src/utils/utils.js